import { useEffect } from "react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function AuthCallback() {
  useEffect(() => {
    const hash = window.location.hash.substring(1);
    const params = new URLSearchParams(hash);
    const idToken = params.get("id_token");
    const error = params.get("error") || new URLSearchParams(window.location.search).get("error");

    if (error || !idToken) {
      window.location.href = "/login?error=auth_failed";
      return;
    }

    fetch(`${API}/auth/google`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "include",
      body: JSON.stringify({ credential: idToken }),
    })
      .then((res) => {
        if (!res.ok) throw new Error("Auth failed");
        return res.json();
      })
      .then((data) => {
        if (data.session_token) localStorage.setItem("session_token", data.session_token);
        window.location.href = "/dashboard";
      })
      .catch(() => {
        window.location.href = "/login?error=auth_failed";
      });
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-50 via-white to-amber-50">
      <div className="text-center space-y-3">
        <div className="spinner mx-auto" />
        <p className="text-sm text-slate-400">Signing you in…</p>
      </div>
    </div>
  );
}
